var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-login"
  }, [_c("div", {
    staticClass: "page-login--layer page-login--layer-area"
  }, [_c("ul", {
    staticClass: "circles"
  }, _vm._l(10, function (n) {
    return _c("li", {
      key: n
    });
  }), 0)]), _c("div", {
    staticClass: "page-login--layer page-login--layer-time",
    attrs: {
      flex: "main:center cross:center"
    }
  }, [_vm._v(" " + _vm._s(_vm.time) + " ")]), _c("div", {
    staticClass: "page-login--layer"
  }, [_c("div", {
    staticClass: "page-login--content",
    attrs: {
      flex: "dir:top main:justify cross:stretch box:justify"
    }
  }, [_vm._m(0), _c("div", {
    staticClass: "page-login--content-main",
    attrs: {
      flex: "dir:top main:center cross:center"
    }
  }, [_c("div", {
    staticClass: "app-name"
  }, [_c("img", {
    staticClass: "page-login--logo",
    attrs: {
      src: require("./image/logo.png")
    }
  }), _c("span", [_vm._v(_vm._s(_vm.appTitle))])]), _c("div", {
    staticClass: "page-login--form"
  }, [_c("el-card", {
    attrs: {
      shadow: "never"
    }
  }, [_c("el-form", {
    ref: "loginForm",
    attrs: {
      model: _vm.formLogin,
      rules: _vm.rules,
      "label-position": "top",
      size: "default"
    }
  }, [_c("el-form-item", {
    attrs: {
      prop: "account"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "用户名",
      type: "text"
    },
    model: {
      value: _vm.formLogin.account,
      callback: function callback($$v) {
        _vm.$set(_vm.formLogin, "account", $$v);
      },
      expression: "formLogin.account"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      prop: "pwd"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "密码",
      type: "password"
    },
    model: {
      value: _vm.formLogin.pwd,
      callback: function callback($$v) {
        _vm.$set(_vm.formLogin, "pwd", $$v);
      },
      expression: "formLogin.pwd"
    }
  })], 1), _c("div", {
    class: _vm.captchaConfig.config.product === "bind" ? "hideHeight" : "",
    attrs: {
      id: "captcha"
    }
  }, [_c("AliCaptcha", {
    attrs: {
      "captcha-config": _vm.captchaConfig
    }
  })], 1), _c("el-button", {
    staticClass: "button-login",
    attrs: {
      loading: _vm.loading,
      size: "default",
      type: "primary"
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v(" 登录 ")])], 1)], 1)], 1)]), _vm._m(1)])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-login--content-header"
  }, [_c("p", {
    staticClass: "page-login--content-header-motto"
  }, [_vm._v(" 时间是一切财富中最宝贵的财富 ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-login--content-footer"
  }, [_c("p", {
    staticClass: "page-login--content-footer-options"
  }, [_c("a", {
    attrs: {
      href: "#"
    }
  }, [_vm._v("帮助")]), _c("a", {
    attrs: {
      href: "#"
    }
  }, [_vm._v("隐私")]), _c("a", {
    attrs: {
      href: "#"
    }
  }, [_vm._v("条款")])])]);
}];
render._withStripped = true;
export { render, staticRenderFns };